import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';

type THIS_API = ApiDefinition['/workflows/user-workflows/{userWorkflowId}/comments/{messageId}']['DELETE'];

type Input = THIS_API['params'];
type Output = THIS_API['response'];

const deleteWorkflowConversationMessage = async ({ userWorkflowId, messageId }: Input): Promise<Output> => {
  const response = await noodleApiClient.delete(`/workflows/user-workflows/${userWorkflowId}/comments/${messageId}`);
  return response.data;
};

export default deleteWorkflowConversationMessage;
